/* Artem Legrand: Judge.me — 1 review, +5 per click, then collapse. */
(function () {
  var STEP = 5;
  var INIT = 1;
  var shown = INIT;
  var total = 0;
  var busy = false;
  var mounted = false;

  var TRANSLATIONS = {
    ja: {
      badge_no_review_text: 'レビューはまだありません',
      widget_title: 'お客様のレビュー',
      widget_open_form_text: 'レビューを書く',
      widget_close_form_text: 'レビューをキャンセル',
      widget_no_review_text: '最初のレビューを投稿しませんか？',
      widget_name_field_text: '表示名',
      widget_name_placeholder_text: '表示名',
      widget_required_field_error_text: 'この項目は必須です。',
      widget_email_field_text: 'メールアドレス',
      widget_email_placeholder_text: 'メールアドレス',
      widget_email_field_error_text: '有効なメールアドレスを入力してください。',
      widget_rating_field_text: '評価',
      widget_review_title_field_text: 'レビューのタイトル',
      widget_review_title_placeholder_text: 'レビューにタイトルを付けてください',
      widget_review_body_field_text: 'レビュー内容',
      widget_review_body_placeholder_text: 'こちらにご記入ください…',
      widget_pictures_field_text: '写真・動画（任意）',
      widget_submit_review_text: 'レビューを投稿',
      widget_submit_verified_review_text: '購入者レビューを投稿',
      widget_show_all_link_text: 'すべて表示',
      widget_show_less_link_text: '表示を減らす',
      widget_read_more_text: '続きを読む',
      widget_sorting_most_recent_text: '新しい順',
      widget_sorting_highest_rating_text: '評価の高い順',
      widget_sorting_lowest_rating_text: '評価の低い順',
      widget_sorting_with_pictures_text: '写真付きのみ',
      widget_reviews_subtab_text: 'レビュー',
      widget_questions_subtab_text: '質問',
      widget_question_label_text: '質問',
      widget_answer_label_text: '回答',
      widget_question_placeholder_text: '質問を入力してください',
      widget_submit_question_text: '質問を送信',
      widget_verified_badge_text: '購入確認済み',
      widget_show_more_text: 'もっと見る',
      widget_load_more_text: 'さらに読み込む',
      custom_show_more: 'もっと見る',
      custom_show_less: '表示を減らす',
      custom_loading: '読み込み中…'
    },
    ko: {
      badge_no_review_text: '리뷰가 아직 없습니다',
      widget_title: '고객 리뷰',
      widget_open_form_text: '리뷰 작성',
      widget_close_form_text: '리뷰 작성 취소',
      widget_no_review_text: '첫 번째 리뷰를 남겨주세요',
      widget_name_field_text: '표시 이름',
      widget_name_placeholder_text: '표시 이름',
      widget_required_field_error_text: '필수 항목입니다.',
      widget_email_field_text: '이메일 주소',
      widget_email_placeholder_text: '이메일 주소',
      widget_email_field_error_text: '올바른 이메일 주소를 입력해 주세요.',
      widget_rating_field_text: '평점',
      widget_review_title_field_text: '리뷰 제목',
      widget_review_title_placeholder_text: '리뷰 제목을 입력해 주세요',
      widget_review_body_field_text: '리뷰 내용',
      widget_review_body_placeholder_text: '여기에 리뷰를 작성해 주세요…',
      widget_pictures_field_text: '사진/동영상(선택 사항)',
      widget_submit_review_text: '리뷰 제출',
      widget_submit_verified_review_text: '인증 리뷰 제출',
      widget_show_all_link_text: '모두 보기',
      widget_show_less_link_text: '간략히 보기',
      widget_read_more_text: '더 읽기',
      widget_sorting_most_recent_text: '최신순',
      widget_sorting_highest_rating_text: '평점 높은순',
      widget_sorting_lowest_rating_text: '평점 낮은순',
      widget_sorting_with_pictures_text: '사진 리뷰만',
      widget_reviews_subtab_text: '리뷰',
      widget_questions_subtab_text: '질문',
      widget_question_label_text: '질문',
      widget_answer_label_text: '답변',
      widget_question_placeholder_text: '질문을 입력해 주세요',
      widget_submit_question_text: '질문 제출',
      widget_verified_badge_text: '구매 인증',
      widget_show_more_text: '더 보기',
      widget_load_more_text: '더 불러오기',
      custom_show_more: '더 보기',
      custom_show_less: '간략히 보기',
      custom_loading: '불러오는 중…'
    },
    'pt-br': {
      badge_no_review_text: 'Nenhuma avaliação',
      widget_title: 'Avaliações de clientes',
      widget_open_form_text: 'Escrever uma avaliação',
      widget_close_form_text: 'Cancelar avaliação',
      widget_no_review_text: 'Seja a primeira pessoa a avaliar',
      widget_name_field_text: 'Nome de exibição',
      widget_name_placeholder_text: 'Nome de exibição',
      widget_required_field_error_text: 'Este campo é obrigatório.',
      widget_email_field_text: 'E-mail',
      widget_email_placeholder_text: 'E-mail',
      widget_email_field_error_text: 'Insira um e-mail válido.',
      widget_rating_field_text: 'Avaliação',
      widget_review_title_field_text: 'Título da avaliação',
      widget_review_title_placeholder_text: 'Dê um título à sua avaliação',
      widget_review_body_field_text: 'Conteúdo da avaliação',
      widget_review_body_placeholder_text: 'Comece a escrever aqui…',
      widget_pictures_field_text: 'Foto/vídeo (opcional)',
      widget_submit_review_text: 'Enviar avaliação',
      widget_submit_verified_review_text: 'Enviar avaliação verificada',
      widget_show_all_link_text: 'Mostrar tudo',
      widget_show_less_link_text: 'Mostrar menos',
      widget_read_more_text: 'Ler mais',
      widget_sorting_most_recent_text: 'Mais recentes',
      widget_sorting_highest_rating_text: 'Melhores avaliações',
      widget_sorting_lowest_rating_text: 'Avaliações mais baixas',
      widget_sorting_with_pictures_text: 'Somente com fotos',
      widget_reviews_subtab_text: 'Avaliações',
      widget_questions_subtab_text: 'Perguntas',
      widget_question_label_text: 'Pergunta',
      widget_answer_label_text: 'Resposta',
      widget_question_placeholder_text: 'Escreva sua pergunta aqui',
      widget_submit_question_text: 'Enviar pergunta',
      widget_verified_badge_text: 'Verificado',
      widget_show_more_text: 'Mostrar mais',
      widget_load_more_text: 'Carregar mais',
      custom_show_more: 'Mostrar mais',
      custom_show_less: 'Mostrar menos',
      custom_loading: 'Carregando…'
    },
    'pt-pt': {
      badge_no_review_text: 'Sem avaliações',
      widget_title: 'Avaliações de clientes',
      widget_open_form_text: 'Escrever uma avaliação',
      widget_close_form_text: 'Cancelar avaliação',
      widget_no_review_text: 'Seja a primeira pessoa a escrever uma avaliação',
      widget_name_field_text: 'Nome de apresentação',
      widget_name_placeholder_text: 'Nome de apresentação',
      widget_required_field_error_text: 'Este campo é obrigatório.',
      widget_email_field_text: 'Endereço de e-mail',
      widget_email_placeholder_text: 'Endereço de e-mail',
      widget_email_field_error_text: 'Introduza um endereço de e-mail válido.',
      widget_rating_field_text: 'Avaliação',
      widget_review_title_field_text: 'Título da avaliação',
      widget_review_title_placeholder_text: 'Dê um título à sua avaliação',
      widget_review_body_field_text: 'Conteúdo da avaliação',
      widget_review_body_placeholder_text: 'Comece a escrever aqui…',
      widget_pictures_field_text: 'Fotografia/vídeo (opcional)',
      widget_submit_review_text: 'Enviar avaliação',
      widget_submit_verified_review_text: 'Enviar avaliação verificada',
      widget_show_all_link_text: 'Mostrar tudo',
      widget_show_less_link_text: 'Mostrar menos',
      widget_read_more_text: 'Ler mais',
      widget_sorting_most_recent_text: 'Mais recentes',
      widget_sorting_highest_rating_text: 'Avaliações mais altas',
      widget_sorting_lowest_rating_text: 'Avaliações mais baixas',
      widget_sorting_with_pictures_text: 'Apenas com fotografias',
      widget_reviews_subtab_text: 'Avaliações',
      widget_questions_subtab_text: 'Perguntas',
      widget_question_label_text: 'Pergunta',
      widget_answer_label_text: 'Resposta',
      widget_question_placeholder_text: 'Escreva a sua pergunta aqui',
      widget_submit_question_text: 'Enviar pergunta',
      widget_verified_badge_text: 'Verificado',
      widget_show_more_text: 'Mostrar mais',
      widget_load_more_text: 'Carregar mais',
      custom_show_more: 'Mostrar mais',
      custom_show_less: 'Mostrar menos',
      custom_loading: 'A carregar…'
    }
  };

  var FRENCH_SETTINGS = {
    badge_no_review_text: "Pas encore d'avis",
    widget_title: 'Avis des clients',
    widget_open_form_text: 'Écrire un avis',
    widget_close_form_text: "Annuler l'avis",
    widget_no_review_text: 'Soyez le premier à écrire un avis',
    widget_name_field_text: 'Nom affiché',
    widget_name_placeholder_text: 'Nom affiché',
    widget_required_field_error_text: 'Ce champ est obligatoire.',
    widget_email_field_text: 'Adresse e-mail',
    widget_email_placeholder_text: 'Adresse e-mail',
    widget_email_field_error_text: 'Veuillez saisir une adresse e-mail valide.',
    widget_rating_field_text: 'Évaluation',
    widget_review_title_field_text: "Titre de l'avis",
    widget_review_title_placeholder_text: 'Donnez un titre à votre avis',
    widget_review_body_field_text: 'Votre avis',
    widget_review_body_placeholder_text: 'Écrivez votre avis ici…',
    widget_pictures_field_text: 'Photo/vidéo (facultatif)',
    widget_submit_review_text: "Envoyer l'avis",
    widget_submit_verified_review_text: "Envoyer l'avis vérifié",
    widget_show_all_link_text: 'Tout afficher',
    widget_show_less_link_text: 'Afficher moins',
    widget_read_more_text: 'Lire la suite',
    widget_sorting_most_recent_text: 'Les plus récents',
    widget_sorting_highest_rating_text: 'Note la plus élevée',
    widget_sorting_lowest_rating_text: 'Note la plus basse',
    widget_sorting_with_pictures_text: 'Avec photos uniquement',
    widget_reviews_subtab_text: 'Avis',
    widget_questions_subtab_text: 'Questions',
    widget_question_label_text: 'Question',
    widget_answer_label_text: 'Réponse',
    widget_question_placeholder_text: 'Saisissez votre question ici',
    widget_submit_question_text: 'Envoyer la question',
    widget_verified_badge_text: 'Vérifié',
    widget_show_more_text: 'Afficher plus',
    widget_load_more_text: 'Charger plus'
  };

  function localeKey() {
    var locale = String(document.documentElement.lang || '').toLowerCase().replace('_', '-');
    if (locale.indexOf('pt-br') === 0) return 'pt-br';
    if (locale.indexOf('pt-pt') === 0 || locale === 'pt') return 'pt-pt';
    if (locale.indexOf('ja') === 0) return 'ja';
    if (locale.indexOf('ko') === 0) return 'ko';
    return '';
  }

  var copy = TRANSLATIONS[localeKey()] || null;

  function applyJudgeMeSettings() {
    if (!copy || !window.jdgmSettings) return;
    Object.keys(copy).forEach(function (key) {
      if (key.indexOf('custom_') !== 0) window.jdgmSettings[key] = copy[key];
    });
  }

  function replacementMap() {
    var replacements = {};
    if (!copy) return replacements;
    Object.keys(FRENCH_SETTINGS).forEach(function (key) {
      replacements[FRENCH_SETTINGS[key]] = copy[key];
    });
    replacements['Voir moins'] = copy.custom_show_less;
    replacements['Afficher plus'] = copy.custom_show_more;
    replacements['Chargement…'] = copy.custom_loading;
    return replacements;
  }

  var replacements = replacementMap();

  function isJudgeMeElement(element) {
    if (!element || element.nodeType !== 1) return false;
    if (element.matches('.jdgm-widget,.jdgm-review-widget,.jm-review-widget,.jm-form,[class*="jdgm"],[class*="jm-"]')) return true;
    return !!element.closest('.jdgm-widget,.jdgm-review-widget,.jm-review-widget,.jm-form,[class*="jdgm"],[class*="jm-"]');
  }

  function translateExact(value) {
    var text = String(value || '');
    var trimmed = text.trim();
    return replacements[trimmed] ? text.replace(trimmed, replacements[trimmed]) : text;
  }

  function localizeJudgeMe(root) {
    if (!copy || !root) return;
    var element = root.nodeType === 1 ? root : root.parentElement;
    if (!isJudgeMeElement(element)) return;

    if (root.nodeType === 3) {
      var translatedText = translateExact(root.nodeValue);
      if (translatedText !== root.nodeValue) root.nodeValue = translatedText;
      return;
    }

    /* MutationObserver can also yield comments and other non-element nodes. */
    if (root.nodeType !== 1) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var translatedNode = translateExact(node.nodeValue);
      if (translatedNode !== node.nodeValue) node.nodeValue = translatedNode;
    }

    var elements = [root].concat(Array.prototype.slice.call(root.querySelectorAll('*')));
    elements.forEach(function (item) {
      ['placeholder', 'aria-label', 'title', 'value'].forEach(function (attribute) {
        if (!item.hasAttribute || !item.hasAttribute(attribute)) return;
        var translated = translateExact(item.getAttribute(attribute));
        if (translated !== item.getAttribute(attribute)) item.setAttribute(attribute, translated);
      });
    });
  }

  applyJudgeMeSettings();

  if (copy) {
    var localizationObserver = new MutationObserver(function (mutations) {
      applyJudgeMeSettings();
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(localizeJudgeMe);
        if (mutation.type === 'characterData') localizeJudgeMe(mutation.target);
      });
    });
    localizationObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
    document.querySelectorAll('.jdgm-widget,.jdgm-review-widget,.jm-review-widget,.jm-form').forEach(localizeJudgeMe);
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.jdgm-widget,.jdgm-review-widget,.jm-review-widget,.jm-form').forEach(localizeJudgeMe);
    });
  }

  function css() {
    return '.jdgm-review-widget .jdgm-review-list > .jm-review-item:nth-child(n+' +
      (shown + 1) +
      '){display:none!important}.jdgm-review-widget .jm-load-more-pagination{display:none!important}';
  }

  function setStyle() {
    var style = document.getElementById('al-jm-collapse');
    if (!style) {
      style = document.createElement('style');
      style.id = 'al-jm-collapse';
      document.head.appendChild(style);
    }
    style.textContent = css();
  }

  function pager() {
    return document.querySelector(
      '.jm-load-more-pagination button,.jm-load-more-pagination [role=button],.jm-load-more-pagination a'
    );
  }

  function loadUpTo(target, callback) {
    busy = true;
    var attempts = 0;
    var timer = setInterval(function () {
      var loaded = document.querySelectorAll('.jm-review-item').length;
      if (loaded >= target || loaded >= total) {
        clearInterval(timer);
        busy = false;
        if (callback) callback();
        return;
      }

      var nextPage = pager();
      if (nextPage) {
        nextPage.click();
        attempts = 0;
      } else {
        attempts += 1;
      }

      if (attempts >= 4) {
        clearInterval(timer);
        busy = false;
        if (callback) callback();
      }
    }, 300);
  }

  function label(button) {
    button.textContent = shown >= total
      ? (copy ? copy.custom_show_less : 'Voir moins')
      : (copy ? copy.custom_show_more : 'Afficher plus');
  }

  function init() {
    if (document.getElementById('al-jm-showall') || total <= 1) return;

    var list = document.querySelector('.jdgm-review-list');
    if (!list || !list.parentElement) return;

    shown = Math.min(INIT, total);
    setStyle();
    loadUpTo(shown);
    if (total <= INIT) return;

    var button = document.createElement('button');
    button.id = 'al-jm-showall';
    button.type = 'button';
    button.className = 'jm-button jm-button--primary';
    button.style.cssText = 'display:block;margin:12px auto 0';
    label(button);
    button.addEventListener('click', function () {
      if (busy) return;
      if (shown >= total) {
        shown = Math.min(INIT, total);
        setStyle();
        label(button);
        var widget = document.querySelector('.jdgm-review-widget');
        if (widget) widget.scrollIntoView({ block: 'center' });
        return;
      }

      var target = Math.min(shown + STEP, total);
      button.textContent = copy ? copy.custom_loading : 'Chargement…';
      loadUpTo(target, function () {
        shown = target;
        setStyle();
        label(button);
      });
    });
    list.parentElement.appendChild(button);
  }

  function tryMount() {
    if (mounted) return true;
    try {
      if (window.jdgm && jdgm.data && jdgm.data.reviewWidget) {
        Object.keys(jdgm.data.reviewWidget).forEach(function (key) {
          var widget = jdgm.data.reviewWidget[key];
          if (widget && widget.pagination) widget.pagination.per_page = 1;
        });
      }

      var selector = document.querySelector('.jm-review-widget select,.jdgm-widget select');
      if (!selector || document.querySelectorAll('.jm-review-item').length < 1) return false;

      try {
        total = Object.values(jdgm.data.reviewWidget)[0].number_of_reviews;
      } catch (error) {
        total = document.querySelectorAll('.jm-review-item').length;
      }
      selector.dispatchEvent(new Event('change', { bubbles: true }));
      mounted = true;
      setTimeout(init, 700);
      return true;
    } catch (error) {
      return false;
    }
  }

  if (!tryMount()) {
    var observer = new MutationObserver(function () {
      if (tryMount()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }
})();
